import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import { setDisplayName, compose } from 'recompose';
import { injectIntl } from 'components';
import ErrorOutline from '@material-ui/icons/ErrorOutline';

export const errorFallback = (WrappedComponent) => {
  class withError extends Component {
    static propTypes = {
      formatMessage: PropTypes.func.isRequired,
    };

    static defaultProps = {};

    state = {
      hasError: false,
    };


    componentDidCatch(error) {
      if (error) {
        this.setState({ hasError: true });
      }
    }

    render() {
      const { formatMessage } = this.props;
      const { hasError } = this.state;
      if (hasError) {
        return (
          <div
            style={{ flexDirection: 'column', justifyContent: 'center' }}
            className="container-fluid vh_height100 d-flex">
            <div className="row ml-auto mr-auto">
              <ErrorOutline
                style={{
                  color: 'rgba(0, 0, 0, 0.5)',
                  width: 200,
                  height: 200,
                }}
              />
            </div>
            <div className="row ml-auto mr-auto">
              <div className="col-12">
                <div className="m-auto">
                  <p style={{ fontSize: 16, fontWeight: 600 }}>{formatMessage('Oops!')}</p>
                  <p style={{ fontSize: 16, fontWeight: 600 }}>{formatMessage('Something went wrong.')}</p>
                </div>
                <div>
                  <p style={{ fontSize: 14 }}>{formatMessage('Our engineers are working around the clock to provide the best experience.')}</p>
                </div>
                <div className="text-center mt-5">
                  <Link to="/track-orders">
                    <Button variant="contained" color="primary">
                      {formatMessage('GO BACK TO HOME')}
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        );
      }
      return <WrappedComponent {...this.props} />;
    }
  }
  return compose(
    setDisplayName('withError'),
    injectIntl,
  )(withError);
};
